import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {PaymentMethodsService} from 'app/services';
import {fetchAllPaymentMethods} from "./paymentmethods-list.slice";
import {PaymentMethodsRequestBoyd} from "app/types/service-types/PaymentMethodsTypes";
import {errorMsg, successMsg} from "../../../../utils/MessageUtils";

interface UpdatePaymentMethodStateParams {
  id: string;
  body: PaymentMethodsRequestBoyd;
  onSuccess?: Function;
  onError?: Function;
}

export const updatePaymentMethod = (params: UpdatePaymentMethodStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await PaymentMethodsService.updatePaymentMethod(params.id, params.body);
    console.log(response);
    if (response.status >= 200 || response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Payment method successfully changed!' : 'Metoda për pagesë u ndryshua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllPaymentMethods());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface UpdatePaymentMethodSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdatePaymentMethodSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'configurations/airports',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;